module.exports = __webpack_public_path__ + "static/media/road.f1ee59ff.svg";